module.exports = __webpack_public_path__ + "img/graduation-cap-solid.0e2a03ad.svg";